import { gql, useMutation } from '@apollo/client';
import {
  CSGetEntity,
  updateEntityUser as UPDATE_ENTITY_USER,
} from '@admiin-com/ds-graphql';

export function useUpdateEntityUser({ entityId }: { entityId: string }) {
  const [updateEntityUserMutation, { data, loading, error }] = useMutation(
    gql(UPDATE_ENTITY_USER),
    {
      refetchQueries: entityId
        ? [
            {
              query: gql(CSGetEntity),
              variables: {
                id: entityId,
              },
            },
          ]
        : [],
    }
  );

  return {
    data,
    mutate: updateEntityUserMutation,
    loading,
    error,
  };
}
